import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getPropinsi() {
  const response = await http
    .getData(`/online/referensi/propinsi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getKabupaten(propId) {
  const response = await http
    .getData(`/online/referensi/propinsi/${propId}/kabupaten`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getKecamatan(kabId) {
  const response = await http
    .getData(`/online/referensi/kabupaten/${kabId}/kecamatan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getPropinsi,
  getKabupaten,
  getKecamatan
};
